import React from "react";
import ConnexionComponent from "@/components/Connexion/ConnexionComponent";
import { CONNEXION_DATA } from "@/constants/data";
import ContactComponent from "@/components/Formulairecontact/ContactComponent";
import { Head } from "@/components/seo";

export default function ConnexionPage() {
  return (
    <>
      <Head title="Connexion" description="Se connecter à votre espace"></Head>
      <div className="pt-2">
        <div className="text-center px-4">
          <p className="text-sm md:text-lg italic text-[#000080]">
            Rejoignez la plateforme de recensement du cheptel sénégalais
          </p>
          <p className="text-md md:text-xl font-bold text-gray-900 mt-1">
            Digitalisez votre élevage et accédez à des données fiables
          </p>
        </div>

        <ConnexionComponent
          title={CONNEXION_DATA.title}
          description={CONNEXION_DATA.description}
          advantages={CONNEXION_DATA.advantages}
          image={CONNEXION_DATA.image}
        />

        <ContactComponent />
      </div>
    </>
  );
}
